/* eslint-disable react-refresh/only-export-components */
import PropTypes from 'prop-types';
import { createContext, useContext, useMemo } from 'react';

const MessageActionContext = createContext({
   allowedActions: [],
   hideAvatar: false,
   hideActions: false,
   hideProgress: false,
   timeFormat: 'message-card',
});

export const MessageActionProvider = ({ children, config = {} }) => {
   const value = useMemo(() => ({ ...config }), [config]);
   return <MessageActionContext.Provider value={value}>{children}</MessageActionContext.Provider>;
};

export const useMessageActionContext = () => useContext(MessageActionContext);

MessageActionProvider.propTypes = {
   children: PropTypes.node.isRequired,
   config: PropTypes.shape({
      allowedActions: PropTypes.arrayOf(PropTypes.string),
      hideAvatar: PropTypes.bool,
      hideActions: PropTypes.bool,
      hideProgress: PropTypes.bool,
      timeFormat: PropTypes.string,
   }),
};
